'use client';

import { FC, useState } from 'react';

import { VatNumber } from '@ravago/shared/page-data/models/elements/vat-number.model';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { Paper } from '@ravago/shared/radiance/components/paper/components/Paper/Paper';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   vatNumbers: Array<VatNumber>;
   trim?: boolean;
}

export const VatNumberList: FC<Props> = ({ vatNumbers, trim = false }) => {
   const translate = useTranslations();
   const [open, setOpen] = useState(false);

   if (vatNumbers?.length === 0) {
      return (
         <Typography color="subtle" variant="small">
            {translate('vat-numbers.no-vat-numbers-found')}
         </Typography>
      );
   }

   const trimmedVatNumbers = trim && !open ? vatNumbers.slice(0, 1) : vatNumbers;
   const totalCount = vatNumbers.length;

   return (
      <Box direction="column">
         {trimmedVatNumbers.map(({ vatNumber, countryName }) => (
            <Paper data-testid="vat-number__list-item" shadow key={vatNumber}>
               <Box direction="row">
                  <Typography data-testid="vat-number" component="h3" variant="body-highlight">
                     {vatNumber}
                  </Typography>
               </Box>

               <Box direction="column" gap="2xs">
                  <Typography data-testid="vat-number__country-name" variant="body">
                     {countryName}
                  </Typography>
               </Box>
            </Paper>
         ))}
         {trim && totalCount > 1 && !open && (
            <Box justify="end">
               <Button variant="tertiary" leadingIcon="chevron-down" onClick={() => setOpen(true)}>
                  {translate('company-info.show-more', { count: totalCount - 1 })}
               </Button>
            </Box>
         )}
      </Box>
   );
};
